export default function detection (agent) {
  let comp_agent = agent.indexOf("kepler") != -1;
  if (comp_agent) {
    console.info ("[Kepler detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/kepler/detection.js